import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

// AppContainer styles moved to AssistantLayout
export const Site = superstyled({
  name: 'AppContainer',
  slot: 'Site',
  styles: ({ theme }) => ({
    position: 'relative',
    transition: theme.transitions.create(['transform'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up('xs')]: {
      overflow: 'hidden',
      minHeight: '100dvh',
      height: '100dvh'
    }
  })
});

export const Page = superstyled({
  name: 'AppContainer',
  slot: 'Page',
  styles: () => ({
    display: 'grid',
    gridTemplateRows: 'minmax(0, auto) minmax(0, 1fr) minmax(0, auto)',
    gridTemplateAreas: `
      "app-container-header"
      "app-container-main"
      "app-container-footer"
    `,
    height: '100%',
    maxWidth: '100%'
  })
});

export const Header = superstyled({
  name: 'AppContainer',
  slot: 'Header',
  propsAdded: {
    component: 'header',
    id: 'app-container-header'
  },
  styles: ({ theme }) => ({
    background: theme.palette.fixed.grey[950],
    alignSelf: 'center',
    gridArea: 'app-container-header'
  })
});

export const MainWrapper = superstyled({
  name: 'AppContainer',
  slot: 'MainWrapper',
  styles: () => ({
    gridArea: 'app-container-main',
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column'
  })
});

// AssistantLayout specific styles
export const LayoutContainer = superstyled({
  name: 'AssistantLayout',
  slot: 'Container',
  tag: Box,
  styles: () => ({
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    position: 'relative'
  })
});

export const SidebarContainer = superstyled({
  name: 'AssistantLayout',
  slot: 'SidebarContainer',
  tag: Box,
  propsNeeded: ['isVisible'],
  styles: ({ theme, isVisible }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: isVisible ? '300px' : '0',
    height: '100%',
    backgroundColor: theme.palette.background.default,
    borderRight: isVisible ? `1px solid ${theme.palette.border.main}` : 'none',
    boxShadow: isVisible ? theme.shadows[8] : 'none',
    transition: 'width 0.3s ease-in-out',
    overflow: 'hidden',
    zIndex: theme.zIndex.drawer,

    [theme.breakpoints.down('md')]: {
      width: isVisible ? '280px' : '0'
    }
  })
});

export const MainContentContainer = superstyled({
  name: 'AssistantLayout',
  slot: 'MainContentContainer',
  tag: Box,
  propsNeeded: ['sidebarVisible'],
  styles: () => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%', // Always take full width
    overflow: 'hidden',
    position: 'relative'
  })
});

export const ContentWrapper = superstyled({
  name: 'AssistantLayout',
  slot: 'ContentWrapper',
  tag: Box,
  styles: () => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  })
});

export const BannerContainer = superstyled({
  name: 'AssistantLayout',
  slot: 'BannerContainer',
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    zIndex: theme.zIndex.appBar - 1
  })
});
